import React from "react";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Ccv() {
  return (
    <>
      <FormTextTC
        name={"pay_provider_sec__ccv__apiKey"}
        tDefault={"apikey"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__ccv__apiKey"}
      />
      <FormTextTC
        name={"pay_provider_sec__ccv__host"}
        tDefault={"host"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__ccv__host"}
      />
      <FormTextTC
        name={"pay_provider_sec__ccv__port"}
        tDefault={"port"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__ccv__port"}
      />
      <FormTextTC
        name={"pay_provider_sec__ccv__terminalId"}
        tDefault={"terminal id"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__ccv__terminalId"}
      />
      <FormTextTC
        name={"pay_provider_sec__ccv__mangementId"}
        tDefault={"management id"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__ccv__mangementId"}
      />
    </>
  );
}

export default Ccv;
